// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../../App.css'
import { Segment, Grid, Placeholder, Container, Feed, Image } from 'semantic-ui-react'
import step1 from '../../assets/step1.png'
import step2 from '../../assets/step2.png'
import step3 from '../../assets/step3.png'
import step4 from '../../assets/step4.png'
import step5 from '../../assets/step5.png'
import step6 from '../../assets/step6.png'
import step7 from '../../assets/step7.png'
import avatar from '../../assets/avatar.jpg'
import CTAWC from '../../components/CTAWC'
import AdSense from 'react-adsense'
import Img from 'react-image'

const ImgLoader = (
  <Placeholder fluid style={{ height: 200 }}>
    <Placeholder.Image />
  </Placeholder>
)

export default class WooCommerceTuto extends Component {
  render () {
    return (
      <Container className='masterdiv'>
        <Grid stackable>
          <Grid.Column width='4' />
          <Grid.Column width='8'>
            <Segment padded>
              <h1>How to create and deploy a WooCommerce Store</h1>
              <Feed>
                <Feed.Event>
                  <Feed.Label>
                    <Image avatar src={avatar} />
                  </Feed.Label>
                  <Feed.Content>
                    <Feed.Summary>
                      <Feed.User>Youssef Selkani</Feed.User>
                      <Feed.Date>12.11.2019</Feed.Date>
                    </Feed.Summary>
                  </Feed.Content>
                </Feed.Event>
              </Feed>
            </Segment>
            <Segment padded>
              <AdSense.Google
                client='ca-pub-8573101599140905'
                slot='2309113111'
                style={{ display: 'block' }}
                format='fluid'
                layoutKey='-fb+5w+4e-db+86'
              />
              <p>
                In this tutorial, I am using{' '}
                <a href='https://pantheon.io/' rel='noopener noreferrer' target='_blank'>
                  Pantheon.io
                </a>{' '}
                for hosting you can choose any hosting provider, if you have a cPanel just go to
                Softaculous App Installer and follow the instructions to install WordPress on the
                server. Once WordPress is installed:
              </p>
              <h3>1.</h3>
              <p>
                Visit yourwebsitesite.com/wp-admin, select the language of your choice and click
                'Continue' button.
              </p>

              <Img style={{ width: '100%' }} loader={ImgLoader} src={step1} />
              <h3>2.</h3>
              <p>
                Fill in the form with basic details about your website and click ‘Install WordPress’
              </p>
              <Img style={{ width: '100%' }} loader={ImgLoader} bordered src={step2} />
              <h3>3.</h3>
              <p>
                You’ll be taken then to the installation success page, enter your credentials and
                hit log in!
              </p>
              <Img style={{ width: '100%' }} loader={ImgLoader} src={step3} />
              <h3>4.</h3>
              <p>
                Once your dashboard is loaded, click on ‘Plugins / Add new plugin’ on the sidebar,
                search for ’WooCommerce’ and install it. Wait a few seconds and activate the plugin.
              </p>
              <Img style={{ width: '100%' }} loader={ImgLoader} src={step4} />
              <h3>5.</h3>
              <p>
                If everything went good you’ll see the WooCommerce Configuration Page, follow the
                instructions (You don’t have to install third-party plugins, avoid installing
                anything you don’t need).
              </p>
              <Img style={{ width: '100%' }} loader={ImgLoader} src={step5} />
              <h3>6.</h3>
              <p>
                At the end of the process, your new e-store is almost ready, setting up payment
                gateway is specific to every user so we won’t cover that. Now you’ll need a theme
                that is compatible with WooCommerce, to install a new theme simply click on
                Appearance > Themes > Add new
              </p>
              <p>
                Search for ‘Storefront’, it’s the official WooCommerce theme, it comes with great
                user interface design and example products, install and activate the theme.
              </p>
              <Img style={{ width: '100%' }} loader={ImgLoader} src={step6} />
              <h3>7.</h3>
              <p>
                When the page reloads you’ll see an alert like the image above, click on the ‘Let’s
                go’ link, this will create a homepage and import demo data.
              </p>
              <p>
                At this point, you can tweak the appearance, add a payment gateway, list your
                products and start selling products online.
              </p>
              <Img style={{ width: '100%' }} loader={ImgLoader} src={step7} />
            </Segment>
            <CTAWC />
          </Grid.Column>
          <Grid.Column width='4' />
        </Grid>
      </Container>
    )
  }
}
